import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Draggable } from 'react-beautiful-dnd';
import ContentIconType from '../Global/Icons/ContentIconType';
import VerticalTextLockup from '../Global/Typography/VerticalTextLockup';

const ContentListItem = ({ index, content, folder, active, onClick, itemMoved }) => {
  const draggableId = `${content.type}-${content.id.toString()}`;
  return (
    <Draggable draggableId={draggableId} index={index} isDragDisabled={!folder.owned_by_me}>
      {(provided, snapshot) => {
        // hide the item while we display a confirmation modal
        if (itemMoved === draggableId) return null;

        const listClass = classNames({
          'bg-grey--bg': active && !snapshot.isDragging,
          'content-list-new__list-item--dragging': snapshot.isDragging,
          'content-list-new__list-item--dragging-delete': snapshot.isDragging && snapshot.draggingOver === `delete`,
        });

        return (
          <li
            ref={provided.innerRef}
            {...provided.draggableProps}
            {...provided.dragHandleProps}
            className={listClass}
          >
            {/* Unfortunately has to be a link instead of a button to work with Draggable https://github.com/atlassian/react-beautiful-dnd#interactive-child-elements-within-a-draggable */}
            <a role="button" tabIndex={0} onClick={onClick}>
              <div className="d-flex">
                <ContentIconType contentType={content.type}/>
              </div>

              <VerticalTextLockup
                title={<h3 className="like-p">{content.title}</h3>}
                subtitle={<div className="like-small">Created by <span
                  className="fw-medium">{content.author_full_name}</span></div>}
              />
            </a>
          </li>
        );
      }}
    </Draggable>
  );
};

ContentListItem.propTypes = {
  index: PropTypes.number.isRequired,
  content: PropTypes.object.isRequired,
  folder: PropTypes.object.isRequired,
  active: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
  itemMoved: PropTypes.string,
};

export default ContentListItem;



// WEBPACK FOOTER //
// ./library/app/components/Folders/ContentListItem.js